// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import Register from "./components/Register";

import AllDetails from "./components/AllDetails";
import CreateDetails from "./components/CreateDetails";
import UpdateDetails from "./components/UpdateDetails";
import AllSiteDetails from "./components/AllSiteDetails";
import Format from "./components/Formats";
import UpiVerify from "./components/UpiVerify";
import MyAmount from "./components/MyAmount";
import All_Customers from "./components/All_Customers";
import BankAccountDetails from "./components/BankAccountDetails";
import BankAccountSubmitted from "./components/BankAccountSubmitted";
import BankAccountPublicEntry from "./components/BankAccountPublicEntry";
import DailyWiseReport from "./components/DailyWiseReport";
import MobileBookingEntry from "./components/MobileBookingEntry";
import MobileBookingsSubmitted from "./components/MobileBookingsSubmitted";
import Metro from "./components/Metro";
import GetAddress from "./components/GetAddress";
import UsedAddresses from "./components/UsedAddresses";
import UpgradeLine from "./components/UpgradeLine";
import UpgradeLineEntry from "./components/UpgradeLineEntry";

import ProtectedRoute from "./components/ProtectedRoute";
import "./styles.css";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/mobile-booking" element={<MobileBookingEntry />} />
        <Route path="/bank-account-entry" element={<BankAccountPublicEntry />} />
        <Route path="/get-address" element={<GetAddress />} />
        <Route path="/used-addresses" element={<UsedAddresses />} />
        <Route path="/upgrade-line" element={<UpgradeLineEntry />} />
        <Route path="/dashboard/get-address" element={<Navigate to="/get-address" replace />} />
        <Route path="/dashboard/used-addresses" element={<Navigate to="/used-addresses" replace />} />

        {/* Protected dashboard + nested pages */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route path="all-details" element={<AllDetails />} />
          <Route path="create-details" element={<CreateDetails />} />
          <Route path="update-details/:id" element={<UpdateDetails />} />
          <Route path="all-sites" element={<AllSiteDetails />} />
          <Route path="format" element={<Format />} />
          <Route path="Upi" element={<Navigate to="/dashboard/UpiVerify" replace />} />
          <Route path="UpiVerify" element={<UpiVerify />} />
          <Route path="mobile-bookings-submitted" element={<MobileBookingsSubmitted />} />
          <Route path="mobile-delivered-items" element={<Navigate to="/dashboard" replace />} />
          <Route path="MyAmount" element={<MyAmount />} />
          <Route path="All_Customers" element={<All_Customers />} />
          <Route path="BankAccountSubmitted" element={<BankAccountSubmitted />} />
          <Route path="BankAccountDetails" element={<BankAccountDetails />} />
          <Route path="DailyWiseReport" element={<DailyWiseReport />} />
          <Route path="Metro" element={<Metro />} />
          <Route path="upgrade-line" element={<UpgradeLine />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
